import PreferenceSelectorItem, {
  PreferenceSelectorItemProps,
} from './PreferenceSelectorItem';

export type {PreferenceSelectorItemProps};
export default PreferenceSelectorItem;
